
export const APP_START = 'APP_START'

export const appStart = () => {
    return {
        type: APP_START,
        payload: {
           id:'id'
        }
    }
}



// WEBPACK FOOTER //
// ./src/Actions/ActionsApp.js